import { ReactNode } from "react";

interface Stat {
  value: number | string | ReactNode;
  label: string | ReactNode;
}

interface PageHeaderProps {
  icon: ReactNode;
  title: string;
  description: string;
  stats?: Stat[];
  actions?: ReactNode;
}

export function PageHeader({
  icon,
  title,
  description,
  stats,
  actions,
}: PageHeaderProps) {
  return (
    <div className="bg-gradient-to-r from-blue-600 to-blue-500 rounded-xl sm:rounded-2xl p-4 sm:p-6 mb-4 sm:mb-6">
      <div className="flex items-start justify-between gap-3 sm:gap-4">
        <div className="flex items-start gap-3 sm:gap-4 min-w-0 flex-1">
          {/* Icon container */}
          <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 bg-white/20 backdrop-blur-sm rounded-lg sm:rounded-xl">
            <div className="text-white">{icon}</div>
          </div>

          {/* Title and description */}
          <div className="min-w-0 flex-1">
            <h1 className="text-lg sm:text-xl md:text-2xl font-semibold text-white truncate">{title}</h1>
            <p className="text-sm sm:text-base text-blue-100 mt-0.5 sm:mt-1 truncate">{description}</p>
          </div>
        </div>

        {/* Actions - sempre alinhado à direita */}
        {actions && (
          <div className="flex-shrink-0 flex items-center gap-2">
            {actions}
          </div>
        )}
      </div>

      {/* Stats */}
      {stats && stats.length > 0 && (
        <div className={`grid ${stats.length === 3 ? "grid-cols-3" : "grid-cols-2"} sm:flex sm:items-center gap-4 sm:gap-6 md:gap-8 mt-4 sm:mt-6`}>
          {stats.map((stat, index) => (
            <div key={index} className="min-w-0">
              <div className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-white truncate">{stat.value}</div>
              <div className="text-[10px] sm:text-xs text-blue-100 uppercase tracking-wide truncate">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
